import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { FaPlus, FaTrash, FaArrowLeft } from 'react-icons/fa';
import { toast } from 'react-toastify';
import bankService from '../services/bankService';

const BankTransactionsPage = () => {
  const { id } = useParams();
  const [account, setAccount] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [balance, setBalance] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      const [accData, txData] = await Promise.all([
        bankService.getAccountById(id),
        bankService.getTransactionsByAccountId(id)
      ]);
      setAccount(accData);
      setTransactions(txData);

      // Bakiyeyi hesapla
      const totalIn = txData.filter(t => t.transaction_type === 'giris').reduce((acc, curr) => acc + Number(curr.amount), 0);
      const totalOut = txData.filter(t => t.transaction_type === 'cikis').reduce((acc, curr) => acc + Number(curr.amount), 0);
      setBalance(totalIn - totalOut);

    } catch (error) {
      toast.error('Veriler yüklenirken hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  const handleDelete = async (txId) => {
    if (window.confirm('Bu hareketi silmek istediğinize emin misiniz?')) {
      try {
        await bankService.deleteTransaction(txId);
        toast.success('Hareket silindi.');
        fetchData();
      } catch (error) {
        toast.error('Silme işlemi başarısız.');
      }
    }
  };

  if (loading) return <div>Yükleniyor...</div>;
  if (!account) return <div>Hesap bulunamadı.</div>;

  return (
    <div className="container-fluid mt-4">
      <div className="d-flex align-items-center mb-4">
        <Link to="/banks" className="btn btn-outline-secondary me-3">
          <FaArrowLeft /> Geri
        </Link>
        <h2 className="mb-0">{account.bank_name} - Hareketler</h2>
      </div>

      <div className="card bg-light mb-4">
        <div className="card-body d-flex justify-content-between align-items-center">
          <div>
            <h5 className="mb-1">{account.branch_name} / {account.iban}</h5>
            <small className="text-muted">Hesap No: {account.account_number}</small>
          </div>
          <div className="text-end">
            <h6 className="text-muted mb-0">Güncel Bakiye</h6>
            <h3 className={`fw-bold ${balance >= 0 ? 'text-success' : 'text-danger'}`}>
              {new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(balance)}
            </h3>
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-end mb-3">
        <Link to={`/banks/detail/${id}/new-transaction`} className="btn btn-primary">
          <FaPlus className="me-2" /> Yeni İşlem Ekle
        </Link>
      </div>

      <div className="card shadow-sm">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Tarih</th>
                  <th>Açıklama</th>
                  <th>Tip</th>
                  <th>Tutar</th>
                  <th>İşlem</th>
                </tr>
              </thead>
              <tbody>
                {transactions.map((tx) => (
                  <tr key={tx.id}>
                    <td>{new Date(tx.transaction_date).toLocaleDateString('tr-TR')}</td>
                    <td>{tx.description}</td>
                    <td>
                      <span className={`badge ${tx.transaction_type === 'giris' ? 'bg-success' : 'bg-danger'}`}>
                        {tx.transaction_type === 'giris' ? 'Giriş' : 'Çıkış'}
                      </span>
                    </td>
                    <td className={tx.transaction_type === 'giris' ? 'text-success fw-bold' : 'text-danger fw-bold'}>
                      {tx.transaction_type === 'giris' ? '+' : '-'} 
                      {new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(tx.amount)}
                    </td>
                    <td>
                      <button onClick={() => handleDelete(tx.id)} className="btn btn-sm btn-outline-danger">
                        <FaTrash />
                      </button>
                    </td>
                  </tr>
                ))}
                {transactions.length === 0 && (
                  <tr>
                    <td colSpan="5" className="text-center">Bu hesaba ait hareket bulunamadı.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BankTransactionsPage;